/**
 * Code utilisé par les flexibles content "form_search_nannies" , "homepage_header" et "search_nounou_no_image"
 * ce code permet de mémoriser la recherche  d'adresse effectué sur ces blocs pour 
 * permettre au formulaire "trouver votre nounou" de passer directement à l'étape 2
 */

(function (w) {
    w.Kinougarde = Object.assign({}, w.Kinougarde, { RechercheNounou: {} });

    /**
     * Mémorise les paramètres de recherche d'une nounou
     */
    w.Kinougarde.RechercheNounou.setRechercheNounou = function (options) {
        window.sessionStorage.setItem("recherchenounou", JSON.stringify(options));
    };

    /**
     * retourne les parametres de recherche d'une nounou ou null
     */
    w.Kinougarde.RechercheNounou.getRechercheNounou = function (options) {
        if (window.sessionStorage.getItem("recherchenounou") !== null) {
            try {
                var param = JSON.parse(window.sessionStorage.getItem("recherchenounou"));
                window.sessionStorage.removeItem("recherchenounou");
                return param;
            }
            catch (e) {
                return null;
            }
        }
        return null;
    };

    /**
     * Initialisation du formulaire de recherche d'une nounou
     */
    w.Kinougarde.RechercheNounou.initFormulaire = function ($form) {

        //Valeur par défaut du formulaire
        var defautlValue = Kinougarde.GetStorage("form-simulation-budgetaire");
        if (typeof (defautlValue) !== 'undefined' && defautlValue !== null) {
            $($form.find("input").each(function () {
                try {
                    var name = this.name;
                    if (typeof (defautlValue[name]) !== 'undefined' && defautlValue[name] !== null) {
                        // si il y a une valeur on affecte la valeur à l'input ayant le même name                                                                 
                        $(this).val(defautlValue[name]);
                        $(this).val(defautlValue[name]).trigger('change'); // Indispensable notament pour le numeric-slider
                        $(this).addClass("input-custom-value");

                    }
                }
                catch (e) {
                    console.debug("donnée d'init non prise en compte");
                }
            }));
        }
        $("#adresse").toggleIconGeoloc();

        // Clic sur le bouton trouver
        $form.find("button").on('click', function (e) {
            e.preventDefault();
            $form.parsley().validate();
            if ($form.parsley().isValid()) {
                var data = {};
                // Recupère toutes les valeurs des champs du formulaire pour les stocker dans un javascript
                $form.serializeArray().forEach(function (value, key) {
                    data[value['name']] = (typeof (value['value']) !== undefined && value['value'] !== "" ? value['value'] : null)
                }
                );

                $(this).loading(
                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        url: ajax_kinougarde_object.ajaxurl,
                        data: Object.assign({ 'action': 'est_desservie' }, data),
                        success: function (reponse) {
                            if (reponse.success) {

                                // Si agence Nouvelle -> redirection vers simulation budgétaire sinon vers trouver nounou                                
                                // Stock la recherche
                                Kinougarde.RechercheNounou.setRechercheNounou(Object.assign(data, { desservie: reponse.data }));
                                // Bloc de recherche d'une nounou
                                if (reponse.data.NouvelleAgence == true) {
                                    document.location.href = "/simulation-budgetaire/";
                                    Kinougarde.TagManagerTunnel('TrouverNounou/step-0', { event: 'TunnelRedirection', TunnelStepRedirect: 'SimulationBudgetaire/step-2' });
                                } else {
                                    document.location.href = "/nounous-pres-de-chez-moi/";
                                }
                            } else {
                                var msg = Kinougarde.Form.getMessageErrorAjax(reponse);
                                $form.find(".form-group").after(msg);
                                dataLayer.push({ event: 'GTMerror', ErrorType: msg });
                                if (reponse.data.error_code == "NON_DESSERVIE") {
                                    dataLayer.push({ 'event': 'COMMUNE_NON_DESSERVIE', ...w.Kinougarde.GetGlobalUtmFields() })
                                }
                                Kinougarde.TagManagerTunnel('TrouverNounou/step-0', { event: 'GTMerror', ErrorType: msg });
                            }

                        },
                        error: function (error) {
                            var msg = Kinougarde.Form.getMessageErrorAjax(reponse);
                            $form.find(".form-group").after(msg);
                            Kinougarde.TagManagerTunnel('TrouverNounou/step-0', { event: 'GTMerror', ErrorType: msg });
                        }
                    }));
                return;
            }
        });
    }



})(window);

jQuery(function () {
    try {
        //Bloc "Home header" de recherche de nounou
        if (jQuery("#section-home-recherche-nounou,#section-recherche-nounou,#section-recherche-nounou-no-image").length > 0) {
            Kinougarde.RechercheNounou.initFormulaire(jQuery("#section-home-recherche-nounou,#section-recherche-nounou,#section-recherche-nounou-no-image").find("form"));
        };
    }
    catch (ex) {
        console.error(ex);
    }
});